// extracted by mini-css-extract-plugin
export default {"modelBox":"ModelBox_modelBox__XEhTj","expand":"ModelBox_expand__fpUaG","default":"ModelBox_default__Af4y+","frame":"ModelBox_frame__aL0eO"};